import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To validate the collected data, you can refer to the appropriate
`}<a parentName="p" {...{
        "href": "/docs/sdk/react-native/2.x.x/primerHeadlessUniversalCheckout/componentWithRedirect/componentWithRedirectManagerProvide#parameters.props"
      }}>{`ComponentWithRedirectManagerProps`}</a>{`
callback functions.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      